// import {
// set,
//   ADDCOMMERCIALNUMBER,
//   ALLCOMMERCIALDETAILS,
//   COMMERCIALNUMFLAG,
//   PREV_INS_LIST,
//   QUICKQUOTE_POST,
//   QUICKQUOE_VALUE,
//   COMMERCIALQUICKQUOTES,
// } from "../actiontypes/NumCommercialActiontypes";
// import axiosCommercial from "../axios/AxiosCommercial";
// export const numCommercialflagfalse = () => {
//   return {
//     type: COMMERCIALNUMFLAG,
//   };
// };
// export const allcommercialdetails = () => {
//   return {
//     type: ALLCOMMERCIALDETAILS,
//   };
// };
// export const addcommercialnum = (data) => {
//   return {
//     type: ADDCOMMERCIALNUMBER,
//     payload: data,
//   };
// };
// export consset = (data) => {
//   return {
//     typeset,
//     payload: data,
//   };
// };
// export function previous_insurance_list(devices) {
//   return {
//     type: PREV_INS_LIST,
//     payload: devices,
//   };
// }
// export function QuickQuote_Post(data) {
//   return {
//     type: QUICKQUOTE_POST,
//     payload: data,
//   };
// }
// export function quick_quoteValues(data) {
//   return {
//     type: QUICKQUOE_VALUE,
//     payload: data,
//   };
// }
// export function quick_quotes_Commercial(data) {
//   return {
//     type: COMMERCIALQUICKQUOTES,
//     payload: data,
//   };
// }
// export const Previousinsurer = () => {
//   return (dispatch, getState) => {
//     return new Promise((resolve, reject) => {
//       axiosCommercial
//         .get("previous_insurer_list")
//         .then(function (response) {
//           console.log(response);
//           dispatch(previous_insurance_list(response.data.data));
//           resolve(response.data.data);
//         })
//         .catch(function (error) {
//           console.log(error.message);
//           reject(error);
//         });
//     });
//   };
// };
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosCommercial from "../axios/AxiosCommercial";

export const fetchPreviousInsurers = createAsyncThunk(
  "commercialdetail/fetchPreviousInsurers",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosCommercial.get("previous_insurer_list");
      return response.data.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const fetchFinancierList = createAsyncThunk(
  "commercialdetail/fetchFinancierList",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosCommercial.get("financier_list");
      return response.data.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
const commercialSlice = createSlice({
  name: "commercialdetail",
  initialState: {
    commercialnum: null,
    iscommercialno: false,
    commercialType: null,
    licensePlate: null,
    RegYear: null,
    make: null,
    model: null,
    varient: null,
    vehicleCoreCode: null,
    permitType: "PUBLIC",
    previousInsurerList: [],
    financierList: [],
    prevPolicyDetail: {},
    quickQuotePost: {},
    quickQuoteValues: {},
    commercialQuickQuotes: [],
    commercialErrQuotes: [],
    idvValue: {},
  },
  reducers: {
    setCommercialNum: (state, action) => {
      console.log("action.payload;", action.payload);
      state.commercialnum = action.payload;
      state.iscommercialno = true;
    },
    setCommercialDetails: (state, action) => {
      const {
        licensePlate,
        RegYear,
        commercialType,
        make,
        model,
        varient,
        vehicleCoreCode,
        permitType,
      } = action.payload;
      state.licensePlate = licensePlate;
      state.RegYear = RegYear;
      state.commercialType = commercialType;
      state.make = make;
      state.model = model;
      state.varient = varient;
      state.vehicleCoreCode = vehicleCoreCode;
      state.permitType = permitType;
    },
    setPrevPolicy: (state, action) => {
      state.prevPolicyDetail = action.payload;
    },
    setQuickQuotePost: (state, action) => {
      state.quickQuotePost = action.payload;
    },
    setQuickQuoteValues: (state, action) => {
      state.quickQuoteValues = action.payload;
    },
    setCommercialQuickQuotes: (state, action) => {
      state.commercialQuickQuotes = action.payload;
    },
    setCommercialErrQuotes: (state, action) => {
      state.commercialErrQuotes = action.payload;
    },
    setCommercialIDV: (state, action) => {
      state.idvValue = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPreviousInsurers.fulfilled, (state, action) => {
        state.loading = false;
        state.previousInsurerList = action.payload;
      })
      .addCase(fetchFinancierList.fulfilled, (state, action) => {
        state.financierList = action.payload;
      });
  },
});

export const {
  setCommercialNum,
  setCommercialDetails,
  setPrevPolicy,
  setQuickQuotePost,
  setQuickQuoteValues,
  setCommercialQuickQuotes,
  setCommercialErrQuotes,
  setCommercialIDV,
} = commercialSlice.actions;

export const getCommercialDetails = (state) => state?.commercialdetail;
export const getComQuickQuotePost = (state) =>
  state?.commercialdetail?.quickQuotePost;
export const getComQuickQuoteInput = (state) =>
  state?.commercialdetail?.quickQuoteValues;
export const getComQuickQuotes = (state) =>
  state?.commercialdetail?.commercialQuickQuotes;

export default commercialSlice.reducer;
